import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { ThreeDotsVertical } from 'react-bootstrap-icons'
import Edit from './edit'
import Attendance from './attendance'
import Duplicate from './duplicate'
import Remove from './remove'
import Message from './message'
import Preview from './preview'
import Enrollment from './enrollment'
import RemoveSeries from './remove-series'
import MassEditItems from './mass-edit-items'

const ExperiencesActionMenu = ({
    experience = {}
}) => {

    return (
        <React.Fragment>
            <Dropdown className='experience-record-action-button'>
                <Dropdown.Toggle variant="link">
                    <ThreeDotsVertical />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <MassEditItems experience={experience}  />
                    <Attendance experience={experience} />
                    <Enrollment experience={experience} />
                    <Preview experience={experience} />
                    <Edit experience={experience} />
                    <Duplicate experience={experience} />
                    <Message experience={experience} />
                    <Remove experience={experience} />
                    <RemoveSeries experience={experience} />
                </Dropdown.Menu>
            </Dropdown>
        </React.Fragment>
    )
}

export default ExperiencesActionMenu